import React, { useEffect, useState } from 'react'
import ContentEditable from 'react-contenteditable'
import { EnhancedColumn, Row } from 'react-table'
import { SelectFieldSlim } from '../fields'

type DataDispatch = {
  type: string
  columnId?: string | number
  rowIndex?: number
  value?: string
}

export default function Cell({
    value: initialValue, row: { index }, column: { id, dataType, options }, dataDispatch
    , uniqueSelectSelection, selectedCategories, rowRemovedHandler
}: {
    value: string, row: Row, column: EnhancedColumn, dataDispatch: ({ type, columnId, rowIndex, value, }: DataDispatch) => void
    , uniqueSelectSelection: boolean, selectedCategories: string[], rowRemovedHandler: {(index:number):any},
}) {
  const [value, setValue] = useState({ value: initialValue, update: false })

  const onChange = (val: string) => {
    setValue({ value: val, update: false })
  }

  useEffect(() => {
    setValue({ value: initialValue, update: false })
  }, [initialValue])

  useEffect(() => {
    setValue({ value: initialValue, update: false })
  }, [])

  useEffect(() => {
    if (value.update) {
      dataDispatch({
        type: 'update_cell', columnId: id, rowIndex: index, value: value.value,
      })
    }
  }, [value, dataDispatch, id, index])

  function removeRow(): void {
      dataDispatch({ type: 'remove_row', rowIndex: index })
      if (rowRemovedHandler) //Optional: may not be passed-in
        rowRemovedHandler(index); // added (OPTIONAL) callback here! 12/Jun/2023
  }

  function getData(): any {
    //selectedCategories is the array of rowID's for rows thus far entered in a Table;
    if (!selectedCategories || !uniqueSelectSelection) {
      return options
    }

    //options is the lookup data; we filter rows already selected so they are removed from dropdown
    return options.filter((elem) => selectedCategories.indexOf(elem.value) === -1 || elem.value === value.value)
  }

  const allowOnlyNumbers = (number: string) => {
    const reg = new RegExp('^[0-9]*(\\.[0-9]+)?$')
    if (reg.test(number)) {
      onChange(number)
    }
    return
  }

  let element
  switch (dataType) {
    case 'text':
      element = (
        <ContentEditable
          html={(value.value && value.value.toString()) || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => setValue((old) => ({ value: old.value, update: true }))}
          className="data-input"
        />
      )
      break
    case 'number':
      element = (
        <ContentEditable
          html={(value.value && value.value.toString()) ?? ''}
          onChange={(e) => allowOnlyNumbers(e.target.value)}
          onBlur={() => setValue((old) => ({ value: old.value, update: true }))}
          className="data-input"
        />
      )
      break
    case 'select':
      element = (
        <SelectFieldSlim<string>
          id="select"
          onChange={(e: any) => {
            onChange(e.value)
            setValue((old) => ({ value: old.value, update: true }))
          }}
          value={value.value}
          dataSource={getData()}
          label=""
        />
      )
      break
    case 'remove':
      element = (
        <span
          title="Remove row"
          className="far fa-trash-alt trash-icon"
          onClick={() => removeRow()}
          role="none"
        />
      )
      break
    default:
      element = <span />
      break
  }

  return element
}
